module.exports = __webpack_public_path__ + "assets/img/37_1629_big.06e2643e.jpg";